<div class="wrapper" *ngIf="!placeholder && (items?.length > 0 || renderWithZeroItems)">
  <app-record-slider
    [items]="swiperItems"
    [showActions]="showActions"
    [showSubheader]="showSubheader"
    [featured]="featured"
    [swiperConfigType]="swiperConfigType"
    [selectedItemIndex]="selectedItemIndex"
    [showSwiperButtons]="!showEmptyBoard"
    (indexClicked)="onSelected($event)">
    <ng-template appSliderTitle>
      <ng-container *ngIf="subtitle; else mainTitle">
        <span tabindex="0" [class.clickable]="preview" (click)="onTitleClicked()"
          >{{ (title | translate) || '&nbsp;' }}</span
        >
      </ng-container>
      <ng-template #mainTitle>
        <h2 tabindex="0" [class.clickable]="preview" (click)="onTitleClicked()">
          {{ (title | translate) || '&nbsp;' }}
        </h2>
      </ng-template>
    </ng-template>

    <ng-template appSliderActions *ngIf="showActions">
      <ng-container [ngTemplateOutlet]="actions.templateRef"></ng-container>
    </ng-template>

    <ng-template appSliderSubheader *ngIf="showSubheader">
      <ng-container [ngTemplateOutlet]="subheader.templateRef"></ng-container>
    </ng-template>
  </app-record-slider>

  <app-slider-item-info
    [collection]="collection"
    [record]="selectedRecord"
    [selectedIndex]="selectedItemIndex"
    [forFavouritesSlider]="isFavouritesSlider"
    [loadedView]="loadedView"
    [class.open]="selectedRecord"
    (close)="onCloseInfo()"></app-slider-item-info>
</div>

<div class="wrapper" *ngIf="placeholder">
  <app-placeholder-swiper [config]="featuredConfig"></app-placeholder-swiper>
</div>
